import { Component, OnInit } from "@angular/core";
import { DetalhesAssinaturaResponse } from "../../modules/shared/arguments/assinatura/DetalhesAssinaturaResponse";
import { AssinaturaService } from "../../modules/shared/services/assinatura.service";

@Component({
  selector: "app-indicador-trial",
  templateUrl: "./indicador-trial.component.html",
  styleUrls: ["./indicador-trial.component.scss"],
})
export class IndicadorTrialComponent implements OnInit {
  public plano!: DetalhesAssinaturaResponse;
  public diasRestantesAvaliacao = 0;
  public strDiasRestantes = "";

  constructor(private assinaturaService: AssinaturaService) {}

  ngOnInit() {
    this.assinaturaService.getplanoplanoAtual().subscribe((plano) => {
      this.plano = plano;

      this.diasRestantesAvaliacao = Math.floor(
        this.plano?.diasRestantesAvaliacao
      );
      this.strDiasRestantes =
        this.diasRestantesAvaliacao === 1 ? "dia" : "dias";

      if (this.plano?.trialGratuito && this.diasRestantesAvaliacao < 0) {
        this.diasRestantesAvaliacao = 0;
      }
    });
  }
}
